export default "__VITE_ASSET__c3e7002f__"